import { Loader2 } from "lucide-react";

export function Loader({ label = "Loading" }) {
    return (
        <div className="flex flex-col items-center justify-center py-24 text-muted-foreground" data-testid="loader">
            <Loader2 className="w-6 h-6 animate-spin text-volt" />
            <span className="mt-3 text-xs uppercase tracking-[0.2em] font-mono">{label}</span>
        </div>
    );
}
